var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGoogleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8442 1.11832C8.44709 2.29682 5.51741 4.53364 3.48551 7.50023C1.4536 10.4668 0.426572 14.0068 0.555269 17.6003C0.683967 21.1937 1.96161 24.6512 4.20053 27.4648C6.43946 30.2784 9.52164 32.2999 12.9944 33.2324C15.8098 33.9589 18.7595 33.9908 21.59 33.3254C24.1541 32.7494 26.5247 31.5174 28.4697 29.75C30.494 27.8544 31.9633 25.4429 32.7197 22.7747C33.5419 19.8732 33.6882 16.8219 33.1473 13.855H17.3373V20.4133H26.4934C26.3104 21.4593 25.9183 22.4577 25.3405 23.3486C24.7627 24.2395 24.0111 25.0047 23.1306 25.5983C22.0126 26.3379 20.7522 26.8355 19.4305 27.0593C18.1049 27.3057 16.7451 27.3057 15.4195 27.0593C14.076 26.7815 12.805 26.2269 11.6875 25.431C9.89227 24.1602 8.5443 22.3548 7.83594 20.2725C7.1156 18.1512 7.1156 15.8515 7.83594 13.7302C8.34016 12.2433 9.17371 10.8894 10.2744 9.76973C11.5339 8.46484 13.1286 7.53209 14.8834 7.07384C16.6382 6.61558 18.4853 6.64951 20.222 7.17192C21.5788 7.58839 22.8194 8.31606 23.8452 9.29692C24.8776 8.26983 25.9082 7.24009 26.937 6.2077C27.4683 5.65254 28.0473 5.12395 28.5706 4.55551C27.0049 3.09849 25.1671 1.96475 23.1625 1.21926C19.512 -0.106236 15.5178 -0.141858 11.8442 1.11832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogleWhite);
export default __webpack_public_path__ + "static/media/logo-google-white.90416839f6b99dba32dc0154a38b979c.svg";
export { ForwardRef as ReactComponent };